import React, { useEffect, useState } from 'react';
import VtrgCenteredImageForm from "../../piece_components/vtrg_centered_image/vtrg_centered_image_form";
import VtrgCustomBlockForm from "../../piece_components/vtrg_custom_block/vtrg_custom_block_form";
import VtrgCustomHtmlForm from "../../piece_components/vtrg_custom_html/vtrg_custom_html_form";
import VtrgInnerBlockForm from "../../piece_components/vtrg_inner_block/vtrg_inner_block_form";
import VtrgJsonImgForm from "../../piece_components/vtrg_json_img/vtrg_json_img_form";
import VtrgSplitScreenForm from "../../piece_components/vtrg_split_screen/vtrg_split_screen_form";
import VtrgTextForm from "../../piece_components/vtrg_text/vtrg_text_form";
import VtrgThreeColumnsForm from "../../piece_components/vtrg_three_columns/vtrg_three_columns_form";
import VtrgVideoForm from "../../piece_components/vtrg_video/vtrg_video_form";
import VtrgWasBecameImageForm from "../../piece_components/vtrg_was_became_image/vtrg_was_became_image_form";

// onFormChange(isOpen) — необязательный, сообщает об открытии/закрытии формы создания блока
// isActive — необязательный, false закрывает открытую форму (открыли добавление блока в другом месте)
const VtrgPanel = ({instanceType, instanceId, updatePiece, setActionLoading, afterUpdateVtrgPiece, onFormChange, isActive = true}) => {
    const [newPieceForm, setNewPieceForm] =  useState(null);

    useEffect(() => {
      if (!isActive) {
        setNewPieceForm(null);
      }
    }, [isActive]);

    const getPieceForm = (form) => {
      setNewPieceForm(form);
      if (onFormChange) {
        onFormChange(!!form);
      }
    };

    const components = [
      { btnClassName: "vtrg-centered-image", component: <VtrgCenteredImageForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgCenteredImage" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },
      { btnClassName: "vtrg-custom-block", component: <VtrgCustomBlockForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgCustomBlock" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },
      { btnClassName: "vtrg-was-became-image", component: <VtrgWasBecameImageForm instanceType={instanceType} instanceId={instanceId}  pieceType="VtrgWasBecameImage" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },
      
      { btnClassName: "vtrg-split-screen", component: <VtrgSplitScreenForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgSplitScreen" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },

      { btnClassName: "vtrg-text", component: <VtrgTextForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgText" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },
      { btnClassName: "vtrg-three-columns", component: <VtrgThreeColumnsForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgThreeColumns" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },

      { btnClassName: "vtrg-json-img", component: <VtrgJsonImgForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgJsonImg" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },
      { btnClassName: "vtrg-custom-html", component: <VtrgCustomHtmlForm instanceType={instanceType} instanceId={instanceId} pieceType="VtrgCustomHtml" updatePiece={updatePiece} setActionLoading={setActionLoading} afterUpdateVtrgPiece={afterUpdateVtrgPiece} getPieceForm={getPieceForm} /> },
    ];

    const changeElement = (item) => {
      updatePiece(null);
      getPieceForm(item.component);
    };

    return (
      <div className="vtrg-add-new-wrapper">
        { newPieceForm && <div> {newPieceForm} </div> }

        <div className="vtrg-new-block-kinds">
          {!!components.length && components.map((item, index)=> {
              return (
                <button className={`btn ${item.btnClassName}`} key={index} onClick={() => { changeElement(item) }}></button>
              )
          })}
        </div>
      </div>
    )
}

export default VtrgPanel;
